"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserAddressExtraReducers = void 0;
const tslib_1 = require("tslib");
const getLoggedUserAddress_1 = tslib_1.__importDefault(require("../../../../user/getLoggedUserAddress"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const deserializer_1 = tslib_1.__importDefault(require("../../../../../utils/deserializer"));
const services_1 = tslib_1.__importDefault(require("../../../../../services"));
const __model__1 = tslib_1.__importDefault(require("./__model__"));
const createUserAddress = toolkitRaw.createAsyncThunk('user/create_user_address', async ({ data, options }, { rejectWithValue, dispatch }) => {
    try {
        const payload = new __model__1.default(data);
        const response = await services_1.default.post('/api/me/addresses', payload.data);
        if (options === null || options === void 0 ? void 0 : options.refreshAddresses) {
            await dispatch((0, getLoggedUserAddress_1.default)());
        }
        const userAddressDeserialize = (0, deserializer_1.default)(response.data);
        return userAddressDeserialize.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
    3;
});
const createUserAddressExtraReducers = (builder) => {
    builder.addCase(createUserAddress.pending, (state) => {
        state.slices.address.loading = true;
    });
    builder.addCase(createUserAddress.fulfilled, (state) => {
        state.slices.address.loading = false;
        state.slices.address.error = false;
    });
    builder.addCase(createUserAddress.rejected, (state) => {
        state.slices.address.loading = false;
        state.slices.address.error = true;
    });
};
exports.createUserAddressExtraReducers = createUserAddressExtraReducers;
exports.default = createUserAddress;
//# sourceMappingURL=index.js.map